import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectorService {
   userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  getDeviceType(): 'android' | 'ios' | 'windows' | 'mac' | 'linux' | 'unknown' {
    if (/android/i.test(this.userAgent)) {
      return 'android';
    }
    if (/iPad|iPhone|iPod/.test(this.userAgent) && !('MSStream' in window)) {
      return 'ios';
    }
    if (/Win/.test(this.userAgent)) {
      return 'windows';
    }
    if (/Mac/.test(this.userAgent)) {
      return 'mac';
    }
    if (/Linux/.test(this.userAgent)) {
      return 'linux';
    }
    return 'unknown';
  }

  isMobile(): boolean {
    return /android|iphone|ipad|ipod/i.test(this.userAgent);
  }

  isDesktop(): boolean {
    return !this.isMobile();
  }

  getDeviceModel(): string {
  const ua = this.userAgent;

  // iOS: limited model info
  if (/iPhone/.test(ua)) return 'iPhone (exact model hidden)';
  if (/iPad/.test(ua)) return 'iPad (exact model hidden)';

  // Android: extract model name
  if (/Android/.test(ua)) {
    const match = ua.match(/Android\s[\d\.]+;\s([^)]+)\)/);
    return match ? match[1].trim() : 'Android Device';
  }

  return 'Unknown';
}
}
